import $ from 'jquery';
import ajaxHttpHeaders from '@/lib/ajaxHttpHeaders';
import appConfig from '@/lib/appConfig';
import DataTable from 'datatables.net-bs5';
import populateFuels from '@/lib/populateFuels';
import urlParam from '@/lib/urlParam';

var compare_id_list = [];
var MAX_NUMBER_COMPARE_LIST_ITEMS = 4;

function results_params() {
  // Build param list for a URL
  var str = "view_mode="+$('#view_mode').val()+"&search_field="+$('#search_field').val()+"&search_dir="+$('#search_dir').val()+"&per_page="+$("#per_page").val()+"&current=true&display_length="+$(".dt-length select").val();

  // Collect model years
  var model_year_ids = [];
  $('input[name="model_year_ids[]"]:checked').each(function() {
    model_year_ids.push(this.value);
  });
  if (model_year_ids.length == 0) {
    str += "&model_year=0";
  } else {
    str += "&model_year=" + model_year_ids.join(',');
  }

  // Collect all the fuels
  var all_fuels_checked = $('#all_fuels:checked').length ? $('#all_fuels').val() : '';
  if (all_fuels_checked == '') {
    var fuel_ids = '';
    $('input[name="fuel_ids[]"]:checked').each(function() {
      fuel_ids += this.value+ ',';
    });
    str += "&fuel_id=" + fuel_ids + "-1";
  } else str += '&all_fuels=y';

  // Collect all the categories
  var all_categories_checked = $('#all_categories:checked').length ? $('#all_categories').val() : '';
  if (all_categories_checked == '') {
    var category_ids = '';
    $('input[name="category_ids[]"]:checked').each(function() {
      category_ids += this.value+ ',';
    });
    str += "&category_id=" + category_ids + "-1";
  } else str += '&all_categories=y';

  // Collect all the manufacturers
  var all_manufacturers_checked = $('#all_manufacturers:checked').length ? $('#all_manufacturers').val() : '';
  if (all_manufacturers_checked == '') {
    var manufacturer_ids = '';
    $('input[name="ld_manufacturer_ids[]"]:checked').each(function() {
      manufacturer_ids += this.value+ ',';
    });
    $('input[name="hd_manufacturer_ids[]"]:checked').each(function() {
      manufacturer_ids += this.value+ ',';
    });
    str += "&manufacturer_id=" + manufacturer_ids + "-1";
  }  else str += '&all_manufacturers=y';
  return str;
}

function ajax_url() {
  return `${appConfig.api_url_root}/v1/vehicles.json?current=true&${results_params()}`;
}

function update_results() {
  // Update browser url (not I.E. compatable)
  var params = results_params();
  var delay = 750;
  history.replaceState({}, "", "?" + params);
  // Update the search results
  var url = "/vehicles/search/results?" + params;
  var csv_url = "/vehicles/search/results.csv?" + params;
  start_ajax_spinner();
  $("#vehicles_csv_download").prop('href', csv_url);

  // update grid_view
  window.gridUrl = url

  // update list view.
  window.ajaxUrl = ajax_url();
  window.ajaxSendTime = Date.now()+delay;
  window.setTimeout(function(){delayed_update_results()}, delay);
}

function delayed_update_results() {
  if (Date.now() >= window.ajaxSendTime) {
    if (window.ajaxGet) {
      window.ajaxGet.abort();
    }
    if (window.datatableAjax) {
      window.datatableAjax.abort();
    }

    window.ajaxGet =  $.ajax({url: window.gridUrl, dataType: "script", cache: true});
    const table = new DataTable('#list_table', { retrieve: true });
    table.ajax.url(window.ajaxUrl).load();
  }
}

window.pagination_client_side_load = function() {
  $(".afdc_pagination .pagination a").on("click", function() {
    var url = "/vehicles/search/results?"+this.href.split("?")[1]
    url = url.replace("#", "").replace("&view_mode=list", '').replace("view_mode=list", '');
    $.ajax({url: url, cache: true, dataType: "script"});
    $('html, body').animate({ scrollTop: $(".results-line").offset().top }, 100);
    start_ajax_spinner();
    return false
  });
}

window.pagination_update_per_page = function() {
  $(".per_page").on("change", function() {
    var url = "/vehicles/search/results?"+results_params()+"&per_page="+$(this).val()
    $.ajax({url: url, cache: true, dataType: "script"});
    start_ajax_spinner();
    return false
  });
}

function start_ajax_spinner() {
  $("#box_view").html('');
  $("#result_spinner").show();
  $("#list_table_wrapper").hide();
}

function hide_zero_results() {
  $("#result_count_0").hide();
  toggle_list_box_view();
}

function show_zero_results() {
  $("#result_count_0").show();
  $('#box_view').hide();
  $('#list_view').hide();
}

window.calculate_vehicle_page_count = function() {
  var view_mode = $("#view_mode").val();
  var total = parseInt($("#vehicle_count").val());
  var page_size = parseInt($(".per_page").val());
  var page = parseInt($(".afdc_pagination .pagination .active").text());
  if (view_mode == 'grid') {
    if ($(".per_page").val() == 'all') {page_size = total;}
    if (isNaN(page)){ page = 1 }
    if (!(isNaN(page_size))) {$("#per_page").val(page_size);}
  } else {
    page_size = parseInt($(".dt-length select").val());
    page = parseInt($(".dt-paging .active").text());
  }

  if (total == 0) {
    $(".num-vehicles").text(total+" vehicles");
  } else {
    var start = ((page-1)*page_size)+1;
    var end = (start+page_size) - 1;
    if ( end > total ) { end = total; }

    if (!(isNaN(start) || isNaN(end))) {
      $(".num-vehicles").text(start+" - "+end+" of "+total+" vehicles");
    }
  }
};

function toggle_list_box_view() {
  if ($('#view_mode').val() == 'list') {
    $('#box_view').hide();
    $('#list_view').show();
    $('#list_table').css('width','');
    $('#box_view_link').css('background-color', '');
    $('#list_view_link').css('background-color', '#eee');
    $('#view_mode').val('list');
  } else {
    $('#box_view').show();
    $('#list_view').hide();
    $('#box_view_link').css('background-color', '#eee');
    $('#list_view_link').css('background-color', '');
    $('#view_mode').val('grid');
  }
  window.calculate_vehicle_page_count();
  $('#box_view_link').click(function(e) {
    e.defaultPrevented;
    $('#box_view').show();
    $('#list_view').hide();
    $('#box_view_link').css('background-color', '#eee');
    $('#list_view_link').css('background-color', '');
    $('#view_mode').val('grid');
    window.calculate_vehicle_page_count();
  });
  $('#list_view_link').click(function(e) {
    e.defaultPrevented;
    $('#box_view').hide();
    $('#list_view').show();
    $('#list_table').css('width', '');
    $('#box_view_link').css('background-color', '');
    $('#list_view_link').css('background-color', '#eee');
    $('#view_mode').val('list');
    // update result line
    window.calculate_vehicle_page_count();
  });
}

function toggle_results_view() {
  if ($("#vehicle_count").val() == '0') {
    show_zero_results();
  } else {
    hide_zero_results();
  }
}

window.remove_compare_item = function(id) {
  $('#close_'+id).parent().remove();
  var index = compare_id_list.indexOf(id.toString());
  if (index > -1 ) {compare_id_list.splice(index, 1);}
  $('input[name="compare_ids[]"][value='+id+']').prop('checked', false);
  if (compare_id_list.length == 0) {
    $('#compare_block').css('display', 'none');
  }
};

function populate_model_years() {
  var checked_model_years = [];
  $("#model_year_search input[name='model_year_ids[]']:checked").each(function() {
    checked_model_years.push(this.value);
  });

  if (checked_model_years.length == 0) {
    $("#model_year").html("None");
  } else {
    $("#model_year").html(checked_model_years.join(", "));
  }
}

function populate_manufacturers() {
  var ld_mans_checked = $("#ld_manufacturer_search input[name='ld_manufacturer_ids[]']:checked");
  var hd_mans_checked = $("#hd_manufacturer_search input[name='hd_manufacturer_ids[]']:checked");
  var ld_mans = $("#ld_manufacturer_search input[name='ld_manufacturer_ids[]']");
  var hd_mans = $("#hd_manufacturer_search input[name='hd_manufacturer_ids[]']");
  // check for all checked
  if (ld_mans_checked.length == ld_mans.length && hd_mans_checked.length == hd_mans.length) {
    $("#manufacturer_name").html("All");
  } else if (ld_mans_checked.length == 0 && hd_mans_checked.length == 0) {
    $("#manufacturer_name").html("None");
  } else {
    var mans = [];
    var index = 0;
    if (ld_mans_checked.length == ld_mans.length) {
      mans[index] = "All light-duty";
    } else {
      $.each( ld_mans_checked, function(num, elem) {
        try {
          mans[num] = $(elem).siblings(".facet_label").text().trim();
        } catch (e) {
          mans[num] = $(elem).siblings(".facet_label").text();
        }
        index = num;
      });
    }
    if (ld_mans_checked.length != 0) {index++;}
    if (hd_mans_checked.length == hd_mans.length) {
      mans[index] = "All medium- and heavy-duty";
    } else {
      $.each( hd_mans_checked, function(num, elem) {
        try {
          mans[index+num] = $(elem).siblings(".facet_label").text().trim();
        } catch (e) {
          mans[index+num] = $(elem).siblings(".facet_label").text();
        }
      });
    }
    $("#manufacturer_name").html(mans.join(", "));
  }
}

function populate_categories() {
  var checked_categories = $("#category_search input[name='category_ids[]']:checked");
  if( checked_categories.length == $("#category_search input[name='category_ids[]']").length ){
    $("#category_name").html("All");
  } else if ( checked_categories.length == 0 ) {
    $("#category_name").html("None");
  } else {
    var categories = [];
    $.each( checked_categories, function(num, elem) {
      // FIXME: IE 8 compatability
      try {
        categories[num] = $(elem).siblings(".facet_label").text().trim();
      } catch(e) {
        categories[num] = $(elem).siblings(".facet_label").text().text();
      }
    });
    $("#category_name").html(categories.join(", "));
  }
}

$(document).ready(function() {
  if (urlParam('ids')) {
    compare_id_list = urlParam('ids').split(",");
  }
  toggle_results_view();

  $('#all_fuels').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).prop('checked') == true) {
      $('input[name="fuel_ids[]"]').prop('checked', true);
    } else {
      $('input[name="fuel_ids[]"]').prop('checked', false);
    }
  });
  $('#all_categories').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).prop('checked') == true) {
      $('input[name="category_ids[]"]').prop('checked', true);
    } else {
      $('input[name="category_ids[]"]').prop('checked', false);
    }
  });
  $('#all_ld_manufacturers').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).prop('checked') == true) {
      $('input[name="ld_manufacturer_ids[]"]').prop('checked', true);
    } else {
      $('input[name="ld_manufacturer_ids[]"]').prop('checked', false);
    }
  });
  $('#all_hd_manufacturers').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    if ($(this).prop('checked') == true) {
      $('input[name="hd_manufacturer_ids[]"]').prop('checked', true);
    } else {
      $('input[name="hd_manufacturer_ids[]"]').prop('checked', false);
    }
  });
  $('.update_results_button').click(function() {
    update_results();
  });

  // set "all" filters
  if ($("#ld_manufacturer_search .fuel-select").length == $("#ld_manufacturer_search .fuel-select input:checked").length) {
    $('#all_ld_manufacturers').prop('checked', true);
  } else {
    $('#all_ld_manufacturers').prop('checked', false);
  }
  if ($("#hd_manufacturer_search .fuel-select").length == $("#hd_manufacturer_search .fuel-select input:checked").length) {
    $('#all_hd_manufacturers').prop('checked', true);
  } else {
    $('#all_hd_manufacturers').prop('checked', false);
  }
  if ($("#category_search .fuel-select").length == $("#category_search .fuel-select input:checked").length) {
    $('#all_categories').prop('checked', true);
  } else {
    $('#all_categories').prop('checked', false);
  }
  if ($("#fuel_tech_search .fuel-select").length == $("#fuel_tech_search .fuel-select input:checked").length) {
    $("#all_fuels").prop('checked', true);
  } else {
    $("#all_fuels").prop('checked', false);
  }

  // show/hide light duty emission info link
  // the link should only display if there are light-duty vehicles in the results
  // these are the ids of the vehicle categories related to light-duty vehicles
  // Sedan/Wagon, SUV, Vocational/Cab Chassis, Van, Pickup
  var ld_category_ids = [27, 29, 17, 9, 25]
  var ld_manufacturers_count = $('#ld_manufacturer_search .fuel-select input:checked').get().length
  var ld_vehicle_categories_count = $('#category_search .fuel-select input:checked')
    .get()
    .map(function(a) {
      return parseInt(a.value)
    }).filter(function(a) {
      return ld_category_ids.indexOf(a) >= 0
    }).length

  if ((ld_manufacturers_count > 0) && (ld_vehicle_categories_count > 0)) {
    $('.ld_emission_info').show()
  } else {
    $('.ld_emission_info').hide()
  }

  $('.facet').click(function() {
    compare_id_list = [];
    $('#compare_list').html('');
    $('#compare_block').css('display', 'none');
    const name = $(this).attr('name');
    if (name === 'ld_manufacturer_ids[]') {
      if ($("#ld_manufacturer_search .fuel-select").length == $("#ld_manufacturer_search .fuel-select input:checked").length) {
        $('#all_ld_manufacturers').prop('checked', true);
      } else {
        $('#all_ld_manufacturers').prop('checked', false);
      }
    }
    if (name === 'hd_manufacturer_ids[]') {
      if ($("#hd_manufacturer_search .fuel-select").length == $("#hd_manufacturer_search .fuel-select input:checked").length) {
        $('#all_hd_manufacturers').prop('checked', true);
      } else {
        $('#all_hd_manufacturers').prop('checked', false);
      }
    }
    if (name === 'category_ids[]') {
      if ($("#category_search .fuel-select").length == $("#category_search .fuel-select input:checked").length) {
        $('#all_categories').prop('checked', true);
      } else {
        $('#all_categories').prop('checked', false);
      }
    }
    if (name === 'fuel_ids[]') {
      if ($("#fuel_tech_search .fuel-select").length == $("#fuel_tech_search .fuel-select input:checked").length) {
        $("#all_fuels").prop('checked', true);
      } else {
        $("#all_fuels").prop('checked', false);
      }
    }
    update_results();
  });

  $('.compare_button').click(function() {
    if (compare_id_list.length > MAX_NUMBER_COMPARE_LIST_ITEMS) {
      alert('You may only select ' + MAX_NUMBER_COMPARE_LIST_ITEMS + ' vehicles to compare.');
      return false;
    } else if (compare_id_list.length > 0) {
      $(this).attr("cursor", "pointer");
      // Collect all the vehicle ids
      var ids = compare_id_list.join(',');

      window.location.href = "/vehicles/search/compare?"+results_params()+"&ids="+ids+"&page_type=vehicle";
    }
  });

  var display_length = parseInt($("#display_length").val());

  new DataTable('#list_table', {
    retrieve: true,
    "ajax": {
      "cache": "true",
      "dataType": 'JSON',
      "url": ajax_url(),
      "headers": ajaxHttpHeaders(),
      "dataSrc": function ( json ) {
        var items = [];
        $.each( json['result'], function( num, obj ) {
          // Name
          var name = obj['manufacturer_name'] + ' ' + obj['model'] + ' ' + obj['model_year'];
          if (obj['heavy_duty_manufacturer_name'] && obj['heavy_duty_manufacturer_name'] != '') {
            name = obj['heavy_duty_manufacturer_name'] + ' ' + obj['model'];

            if (obj['heavy_duty_weight_class']) {
              name = name + ' - ' + obj['heavy_duty_weight_class']['name'];
            }
          }

          // Fuel
          var fuel_name = '';
          if (obj['fuel_name'])
            fuel_name = obj['fuel_name'];
          if (obj['fuels'] && Array.isArray(obj['fuels'])) {
            $.each(obj['fuels'], function(num, fuelarr) {
              if (fuel_name != '') fuel_name += ' | ';
              fuel_name += fuelarr['name'];
            });
          }
          var fuel_name_row_after = fuel_name;
          if (obj['phev_type']) {
            fuel_name_row_after += ' (<a href="/glossary#PHEVConfiguration" class="glossary">' +  (obj['phev_type'] === 'Blended' ? 'Parallel' : 'Series') + '</a>)';
          }

          // Transmission types
          var transmission_type = '';
          if (obj['transmission_make'] != '' && obj['transmission_make'] != null) {
            transmission_type = obj['transmission_make'] + ' ';
          }
          if (obj['heavy_duty_transmission_types'] && Array.isArray(obj['heavy_duty_transmission_types'])) {
            $.each(obj['heavy_duty_transmission_types'], function(num, tt) {
              if (transmission_type != '') transmission_type += '/';
              transmission_type += tt['name'];
            });
          }
          // Emissions Certifications
          var emissions_cert = '';
          if (obj['heavy_duty_emission_certifications'] && Array.isArray(obj['heavy_duty_emission_certifications'])) {
            $.each(obj['heavy_duty_emission_certifications'], function(num, tt) {
              if (emissions_cert != '') emissions_cert += ', ';
              emissions_cert += tt['name'];
            });
          }
          // Category
          var category_name = '';
          if (obj['category_name'] != '' && obj['category_name'] != null) category_name = obj['category_name'];

          // builds fuel economy info for results table data and details row
          var fuel_econ_obj = {
            altCity: obj['alternative_fuel_economy_city'],
            altHwy: obj['alternative_fuel_economy_highway'],
            convCity: obj['conventional_fuel_economy_city'],
            convHwy: obj['conventional_fuel_economy_highway'],
            altComb: obj['alternative_fuel_economy_combined'],
            convComb: obj['conventional_fuel_economy_combined'],
            phevType: function(fuelEconType) {
              if (obj['phev_type'] && fuelEconType === 'alt') {
                if (obj['phev_type'] === 'Blended') {
                  return ' - Gas and Electric:'
                } else {
                  return ' - Electric Only:'
                }
              } else {
                return ':'
              }
            },
            determineFuelEconomyUnit: function(fuelCode) {
              var mpgTypes = ['E85_GSLN', 'BD', 'HYBR']
              if (mpgTypes.indexOf(fuelCode) > -1 || fuelCode === 'mpg') {
                return 'mpg'
              } else {
                return 'MPGe'
              }
            },
            detailsInfo: function(fuelEconType) {
              var fuelUnit = this.determineFuelEconomyUnit(obj['fuel_code'])
              var econType = 'Alternative'

              if (fuelEconType !== 'alt') {
                econType = 'Conventional'
                fuelUnit = 'mpg'
              }

              var detailString = '<strong>' + econType + ' Fuel Economy (Combined)' + this.phevType(fuelEconType) + '</strong> '

              var mpgInfo = '';

              if (this[fuelEconType + 'Comb']) {
                mpgInfo += this[fuelEconType + 'Comb'] + ' ' + fuelUnit;
              }

              if (obj['fuel_economy_estimated_by_manufacturer'] === true) {
                mpgInfo += '<div class="estimated">estimated</div>';
              }

              mpgInfo == '' ? detailString = '' : detailString += mpgInfo + '<br>';

              return detailString;
            },
            fuelsInfoForDetailsRow: function() {
              var alternative = this.detailsInfo('alt')
              var conventional = this.detailsInfo('conv')
              if (this.altCity || this.altHwy || this.convCity || this.convHwy || this.altComb || this.convComb) {
                return alternative + conventional
              } else {
                return ''
              }
            },
            listInfo: function(fuelEconType, label) {
              var fuelUnit = this.determineFuelEconomyUnit(fuelEconType === 'conv' ? 'mpg' : obj['fuel_code'])
              return this[fuelEconType + 'Comb'] + ' ' + fuelUnit + ' ' + label
            },
            fuelsInfoForListTable: function() {
              if (this.altComb && this.convComb) {
                return this.listInfo('alt', 'alternative') + ' | ' + this.listInfo('conv', 'conventional')
              } else if (this.altComb) {
                return this.listInfo('alt', 'combined')
              } else if (this.convComb) {
                return this.listInfo('conv', 'combined')
              } else {
                return ''
              }
            },
          }

          // Fuel Economy for list table
          var fuel_econ = '<i>no data</i>';
          if (obj['class'] === 'LightDutyAutomobile') fuel_econ = fuel_econ_obj.fuelsInfoForListTable()

          var chked = '';

          if ($.inArray((obj['class'] + "_" + obj['id']).toString(), compare_id_list) >= 0) {
            chked = 'checked';
            $('#compare_block').css('display', 'block');
            $('#compare_block').css('height', 'auto');
            $('#compare_list').html($('#compare_list').html() + "<div class='item_box'><span style='float:left;'>"+name+"&nbsp;</span><a href='javascript:window.remove_compare_item(\""+obj['class'] + "_" + obj['id']+"\");' id='close_"+obj['class'] + "_" + obj['id']+"' class='close_x'>X</a></div>");
          }
          var compare = '<input type="checkbox" id="compare_ids_" name="compare_ids[]" class="form-check-input" data-name="'+name+'" value="' + obj['class'] + "_" + obj['id'] + '" ' + chked + '>';
          // Detail row
          var row_after = '<h3>' + name + '</h3> \
              <div class="row list_accordion_detail" style="">';

          var cn = '';
          if (category_name != '') {
            cn = category_name;
          } else {
            if (obj['vehicle_categories'].length != 0) {
              cn = obj["vehicle_categories"][0]['name'];
            }
          }
          var category_display_name = category_name === 'SUV' ? 'SUV' : category_name.toLowerCase();
          cn = cn.toLowerCase().replace(/[^\w]+/g, '-');
          if (obj['photo_url'] != '' && obj['photo_url'] != null) {
            row_after += `<div class="col-md-2"><img class="img-fluid vehicle_image" src="${obj['photo_url']}" loading="lazy" alt=""></div>`;
          }  else  {
            row_after += `<div class="col-md-2"><i class="img-fluid vehicle_image not-pictured not-pictured-${cn}"></i></div>`;
          }

          row_after += '<div class="col-md-3">'+fuel_name_row_after+'<br>'+category_display_name;

          if (obj['seating_capacity'] > 0) {
            row_after += '<br>' + obj['seating_capacity'] + ' seats';
          }

          if (obj['base_msrp'] > 0) {
            row_after += '<br>$' + obj['base_msrp'].toLocaleString() + ' base MSRP';
          }

          row_after += '</div><div class="col-md-6">';

          // Fuel Economy for details row
          row_after += fuel_econ_obj.fuelsInfoForDetailsRow()

          if (obj['electric_range']) {
            row_after += '<strong>Electric-Only Range:</strong> ' + obj['electric_range'] + ' miles<br>'
          }

          if (obj['total_range']) {
            row_after += '<strong>Total Range:</strong> ' + obj['total_range'] + ' miles<br>'
          }

          if (obj['charging_rate_level_2'] || obj['charging_rate_dc_fast']) {
            row_after += '<strong>Charging Rate:</strong><br><li>';

            if (obj['charging_rate_level_2']) {
              row_after += '<i>Level 2:</i> ' + obj['charging_rate_level_2'] + ' kW';
            }

            if (obj['charging_rate_level_2'] && obj['charging_rate_dc_fast']) {
              row_after += ' | ';
            }

            if (obj['charging_rate_dc_fast']) {
              row_after += '<i>DC Fast:</i> ' + obj['charging_rate_dc_fast'] + ' kW';
            }

            row_after += '</li>';
          }

          if (obj['charging_speed_level_1'] || obj['charging_speed_level_2'] || obj['charging_speed_dc_fast']) {
            row_after += '<strong>Charging Speed (per hour of charging):</strong><li>';

            if (obj['charging_speed_level_1']) {
              row_after += '<i>Level 1:</i> ' + obj['charging_speed_level_1'] + ' miles';
            }

            if ((obj['charging_speed_level_1'] && obj['charging_speed_level_2']) || (obj['charging_speed_level_1'] && obj['charging_speed_level_2'] && obj['charging_speed_dc_fast'])) {
              row_after += ' | ';
            }

            if (obj['charging_speed_level_2']) {
              row_after += '<i>Level 2:</i> ' + obj['charging_speed_level_2'] + ' miles';
            }

            if (obj['charging_speed_level_2'] && obj['charging_speed_dc_fast']) {
              row_after += ' | ';
            }

            if (obj['charging_speed_dc_fast']) {
              row_after += '<i>DC Fast:</i> ' + obj['charging_speed_dc_fast'] + ' miles';
            }

            row_after += '</li>';
          }

          if (obj['battery_capacity_kwh'] > 0) {
            row_after += '<strong>Battery Capacity:</strong> ' + obj['battery_capacity_kwh'] + ' kWh<br>';
          }

          if (emissions_cert != '') {
            row_after += '<strong>Emission Certification:</strong> '+emissions_cert+'<br>';
          }

          if (obj['num_passengers'] != '' && obj['num_passengers'] != null) {
            row_after += '<strong>Maximum Seating:</strong> '+obj['num_passengers']+'<br>';
          }

          if (obj['engine_description'] != '' && obj['engine_description'] != null) {
            row_after += '<strong>Engine/Motor(s):</strong> '+obj['engine_description']+'<br>';
          }

          if (transmission_type != '') {
            row_after += '<strong>Transmission:</strong> '+transmission_type+'<br>';
          }

          if (obj['drivetrain'] && obj['drivetrain'] != '') {
            row_after += '<strong>Drivetrain:</strong> ' + obj['drivetrain'] + '<br>';
          }

          if (obj['heavy_duty_engines'] != null && obj['heavy_duty_engines'].length > 0) {
            row_after += '<strong>Power Source(s):</strong><br>';
            $.each(obj['heavy_duty_engines'], function(num, vehicle) {
              row_after += '<li>'+vehicle['heavy_duty_manufacturer_name']+ ' '+vehicle['model']+'</li>';
            });
          }

          if (obj['heavy_duty_hybrids'] != null && obj['heavy_duty_hybrids'].length > 0) {
            row_after += '<strong>Hybrid System(s):</strong><br>';
            $.each(obj['heavy_duty_hybrids'], function(num, vehicle) {
              row_after += '<li>'+vehicle['heavy_duty_manufacturer_name']+ ' '+vehicle['model']+'</li>';
            });
          }

          if (obj['notes']) {
            row_after += '<div class="notes_box"><strong>Note:</strong> ' + obj['notes'] + '</div>';
          }

          row_after += '</div>';

          if (obj['manufacturer_url'] != '' && typeof(obj['manufacturer_url']) != "undefined" ) {
            row_after += '<div style="float:right;margin-right:14px;"><a href="' + obj['manufacturer_url'] + '">Find a Dealer</a></div>';
          }
          row_after += '</div>';

          items.push([`<i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i>${name}`, fuel_name, fuel_econ, compare, row_after]);
        });
        populate_model_years(json);
        populateFuels(json);
        populate_categories(json);
        populate_manufacturers();
        $('#num_vehicles').html(items.length);
        $("#vehicle_count").val(items.length);
        toggle_results_view();
        return items;
        // }
      },
      "beforeSend": function (xhr) {
        window.datatableAjax = xhr;
        $("#result_spinner").show();
        $("#list_table_wrapper").hide();
      }
    },
    "language": {
      info:"Showing _START_ to _END_ of _TOTAL_",
      infoFiltered:"",
      zeroRecords:"No results to display",
      lengthMenu: '<span class="fw-bold me-1">Vehicles per page:</span> _MENU_',
      infoEmpty:"0 results",
    },
    "pageLength": display_length,
    "columns": [
      { width: "400px", "class": 'vehicle-name' },
      { width: "200px" },
      { width: "200px", "type": "numeric", "orderDataType": "mpg" },
      { width: "80px", "orderable": false, 'class': 'compare_checkbox' },
      { width: 0, "visible": false}
    ],
    layout: {
      topStart: '',
      topEnd: '',
      bottomStart: 'pageLength',
      bottomEnd: {
        paging: {
          firstLast: false,
        },
      },
    },
    "searching": false,
    "processing": false,
    "preDrawCallback": function(){
      // colapse expanded rows
      $("tr.expanded").next().remove();
      $("tr.expanded").removeClass('expanded');
    },
    "drawCallback": function() {
      const table = this.api();

      // Add event listener for opening and closing details
      $('#list_table td').off('click');
      $('#list_table td').on('click', function(e) {
        if ($(e.target).is('input')) {
          return;
        }
        var row = $(this).parent();
        if (!row.hasClass('expanded')) {
          const pRow = table.row(this).data(); // getting the values in the columns
          row.after('<tr class="detail_row"><td colspan="4" class="card_view_in_list">'+pRow[4]+'</td></tr>');
          row.addClass('expanded');
          row.addClass('highlighted_row');
        } else {
          row.removeClass('expanded');
          row.removeClass('highlighted_row');
          $(this).parent().next().remove();
        }
      });
      $('#list_table input[name="compare_ids[]"]').off('click');
      $('#list_table input[name="compare_ids[]"]').on('click', function() {
        if (compare_id_list.length >= MAX_NUMBER_COMPARE_LIST_ITEMS && $(this).prop('checked') == true) {
          alert('You may only select ' + MAX_NUMBER_COMPARE_LIST_ITEMS + ' vehicles to compare.');
          $(this).prop('checked', false);
        } else {
          if ($(this).prop('checked') == true) {
            compare_id_list.push($(this).val());
            $('#compare_block').css('display', 'block');
            $('#compare_block').css('height', 'auto');
            $('#compare_list').html($('#compare_list').html() + "<div class='item_box'>"+$(this).attr('data-name')+" <a href='javascript:window.remove_compare_item(\""+$(this).val()+"\");' id='close_"+$(this).val()+"' class='close_x'>X</a></div>");
          } else {
            window.remove_compare_item($(this).val());
          }
        }
      });
      window.calculate_vehicle_page_count();
      $("#result_spinner").hide();
      $('#list_table').css('width', '');
      $("#list_table_wrapper").show();
    },
    initComplete: function() {
      // Trigger drawCallbac() after fully initialized as a workaround for
      // pagination not being fully setup during initial draw (this could be
      // cleaned up):
      // https://datatables.net/forums/discussion/79816/datatables-2-paging-dom-only-appears-after-the-drawcallback
      const table = this.api();
      table.draw();
    },
  });

  window.pagination_client_side_load();
  window.pagination_update_per_page();

});
